import { render, staticRenderFns } from "./BuyScorm.vue?vue&type=template&id=2dc212e0&"
import script from "./BuyScorm.vue?vue&type=script&lang=js&"
export * from "./BuyScorm.vue?vue&type=script&lang=js&"
import style0 from "./BuyScorm.vue?vue&type=style&index=0&id=2dc212e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports